import { LegalLayout, IssuerBlock, ProductOwnerNote, useLegalInfo } from "@/components/LegalLayout";

export default function Privacy() {
  const info = useLegalInfo();
  return (
    <LegalLayout title="Política de Privacidade" testid="privacy-page">
      <ProductOwnerNote info={info} />
      <p>Esta política explica como tratamos os dados pessoais das pessoas que usam a plataforma GestaCV.</p>
      <h2>1. Responsável pelo tratamento</h2>
      <IssuerBlock info={info} />
      <h2>2. Dados que recolhemos</h2>
      <ul>
        <li>Dados da conta: nome, email, telefone e dados da empresa (nome, NIF, ilha, setor).</li>
        <li>Dados que a empresa introduz na plataforma (clientes, orçamentos, vendas, documentos).</li>
        <li>Dados de pagamento da subscrição: referência e estado do pagamento. Os dados do cartão são introduzidos na página segura da SISP (Vinti4) ou da Stripe e não ficam guardados no GestaCV.</li>
      </ul>
      <h2>3. Para que usamos os dados</h2>
      <p>Para prestar o serviço, gerir a subscrição e os pagamentos, emitir Recibos, enviar avisos sobre a conta (por exemplo, renovação do plano) e dar suporte.</p>
      <h2>4. Partilha com prestadores de serviço</h2>
      <p>Não vendemos dados pessoais. Os dados só são partilhados com os prestadores necessários ao serviço:</p>
      <ul>
        <li>Emergent — alojamento da aplicação, base de dados e ficheiros.</li>
        <li>Resend — envio dos emails da plataforma (boas-vindas, recuperação de palavra-passe, Recibos, avisos).</li>
        <li>SISP (Vinti4) — pagamentos com cartões emitidos em Cabo Verde.</li>
        <li>Stripe — pagamentos com cartões internacionais.</li>
        <li>Anthropic (Claude) — geração de textos com IA no módulo Marketing, só quando a empresa usa essa função.</li>
      </ul>
      <h2>5. Conservação</h2>
      <p>Os dados são conservados enquanto a conta estiver ativa. Após o encerramento da conta, os dados da empresa são eliminados a pedido; os Recibos e registos de pagamento são conservados durante o prazo exigido pela legislação fiscal e contabilística de Cabo Verde.</p>
      <h2>6. Direitos</h2>
      <p>Pode pedir acesso, retificação ou eliminação dos seus dados através de {info.email}. Respondemos em até 3 dias úteis.</p>
    </LegalLayout>
  );
}
